/**
 * 공지 본문(2026-09-27 way 「기존 시스템에서 올린 공지가 코드로 나온다」).
 *
 * 레거시 버스인 공지는 **HTML 로 저장**돼 있다(1,328건 중 790건 — `<table style=…>`·`<img>`·`<a>`·`<font>`·`<center>`).
 * 글자로 찍으면 태그가 그대로 보인다. → HTML 이면 **DOMPurify 로 걸러서** 그린다.
 *  - 스크립트·iframe·form·이벤트 속성(onclick 등)·javascript: 링크는 DOMPurify 기본값이 지운다.
 *  - 인라인 style 은 남긴다(레거시 공지의 표·글자 모양이 거기 있다). 단 화면을 덮을 수 있는 `position` 은 뺀다.
 *  - 링크는 새 창으로(기사앱 안에서 부고장·청첩장 페이지로 넘어가 버리지 않게) + `noopener`.
 *  - 그림·표는 폰 폭을 넘지 않게(`.notice-body` — globals.css).
 * 태그가 없는 글(웹에서 새로 쓴 공지)은 줄바꿈을 살려 글자 그대로.
 */

import DOMPurify from 'dompurify';
import { useMemo } from 'react';

const HTML_RE = /<(?:[a-z][a-z0-9]*)(?:\s[^>]*)?\/?>/i;

let hooked = false;
function hookOnce() {
  if (hooked) return;
  hooked = true;
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node instanceof HTMLElement) {
      node.style.removeProperty('position');
      node.style.removeProperty('z-index');
    }
    if (node.tagName === 'A' && node.getAttribute('href')) {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
}

export function sanitizeNoticeHtml(html: string): string {
  hookOnce();
  return DOMPurify.sanitize(html, {
    FORBID_TAGS: ['style', 'form', 'input', 'button', 'textarea', 'select', 'iframe', 'object', 'embed'],
    ADD_ATTR: ['target'],
  });
}

export default function NoticeBody({ text }: { text: string | null | undefined }) {
  const body = text ?? '';
  const isHtml = HTML_RE.test(body);
  const html = useMemo(() => (isHtml ? sanitizeNoticeHtml(body) : ''), [body, isHtml]);

  if (!body.trim()) return <p className="text-lg text-ink-soft">내용이 없습니다.</p>;
  if (!isHtml) return <div className="whitespace-pre-wrap text-lg leading-relaxed text-ink">{body}</div>;
  // eslint-disable-next-line react/no-danger -- 위에서 DOMPurify 로 거른 HTML 만 넣는다.
  return <div className="notice-body text-lg leading-relaxed text-ink" dangerouslySetInnerHTML={{ __html: html }} />;
}
